import React from 'react';
import UsageCountIconSvg from '../../../../../../assets/icons/usage-count-icon.svg';

export const UsageCountIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    return (
        <img
            src={UsageCountIconSvg}
            alt="Usage Count"
            className={className}
        />
    );
};
